import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

interface BannerItem {
  src: string,
  url: string,
  alt: string
}

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.css'
})
export class BannerComponent implements OnInit {
  
  banners: BannerItem[] = [];

  ngOnInit(): void {
    const imgsFolder = './assets/imgs/compressed';
    this.banners = [
      /*
      {
        src: `${imgsFolder}/SustainableForum_2024_web_1000x250.webp`,
        url: 'https://classagora.it/eventi/sustainable-future-forum-e-mf-esg-awards-2024?utm_source=banner&utm_medium=banner&utm_campaign=sustainablefutureforum',
        alt: 'Sustainable Forum'
      },*/
      {
        src: `${imgsFolder}/Masthead-Anticipa_i_mercati.webp`,
        url: 'https://www.milanofinanza.it/abbonamenti?utm_source=skin&utm_medium=mf+wsj+barrons&utm_campaign=campagnaconversione',
        alt: 'Anticipa i mercati'
      },/*
      {
        src: `${imgsFolder}/Masthead-Marketing.webp`,
        url: 'https://us06web.zoom.us/webinar/register/WN_OZ27sga6TOSlDLLtFinpMw',
        alt: 'Marketing'
      },*/
      {
        src: `${imgsFolder}/BannerFIDA_1000x250.webp`,
        url: 'https://www.fidaonline.com/',
        alt: 'FIDA Finanza Dati Analisi'
      },
      {
        src: `${imgsFolder}/BannerFWS_1000x250.webp`,
        url: 'https://www.fidaworkstation.it/',
        alt: 'FIDAworkstation'
      },
    ];

    // Randomizzo l'ordine dei banner
    for (let i = this.banners.length -1; i > 0; i--) {
      let j = Math.floor(Math.random() * i)
      let k = this.banners[i]
      this.banners[i] = this.banners[j]
      this.banners[j] = k
    }
  }

}
